 /* eslint-disable */
import Copyright from 'components/footer/Copyright'
import Footer from 'components/footer/Footer'
import Navbar from 'components/navbar/Navbar'
//import Navbar2 from 'components/navbar/Navbar2'
import PinMapContent from 'components/pinMapContent/PinMapContent'
import Modal from 'containers/modal/Modal'
import { useRequest } from 'hooks/useRequest'
import { useDispatch, useSelector } from 'react-redux'
import { authModalOpen, getAllBasketFunc, homeAddressReChoice, setPinMapModal, setSiteSEttings, setUserInfo } from 'redux/features/general/generalSlice'
import { useEffect, useLayoutEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Loader from 'pages/Loader'
import Navbar2 from 'components/navbar/Navbar2'
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom'
import useScript from 'utils/ScriptConvert'
import {setAnnouncementModal, setPopupList} from 'redux/popup/popupSlice'
import auth from 'utils/Auth'
import AnnouncementModal from 'containers/modal/AnnouncementModal'
import moment from 'moment'
import LoaderTwo from 'pages/LoaderTwo'
import { Helmet } from 'react-helmet'
import AllModal from 'containers/modal/AllModal'
import images from 'assets/images/images'
import useTranslate from 'hooks/useTranslate'
import {HomeAddressChoiceStep} from 'components/homeAddressChoiceStep/HomeAddressChiceStep'
import TagManager from 'react-gtm-module'
import {dataLayerPush} from 'utils/Datalayer'
import Cookie from 'components/home/Cookie'
const Layout = () => {
	const { general, popup } = useSelector((state) => state)
	const { siteSettings, pinMapModal, getAllBasket,useTrigger, authModal, openStatus } = general
	const { autoPopups, triggerPopups, announcementModal } = popup
	const { common, socialMedia, tracking } = siteSettings
	const { footerPhoneLogoPath, footerLogoPath, etbisImagePath, etbisUrl, logoPath } = common ? common : ''
	const { facebookPixelId, googleAnalyticsId, googleTagManagerId } = tracking ? tracking : ""
	const [navbarStatus, setNavbarStatus] = useState(null)
	const dispatch = useDispatch()
	const location = useLocation()
	const [getSiteSEttings, siteSettingLoading] = useRequest()
	const [getSitePopups] = useRequest()
	const [request, loading] = useRequest()
	const navigate = useNavigate();
    const { t } = useTranslate()
		const [cookieValues, setCookieValues] = useState({
			ad_storage:'denied',
			ad_user_data:'denied',
			analytics_storage:'denied',
			functionality_storage:'denied',
			ad_personalization:'denied'
		  })
		  	const [cookieOpen, setCookieOpen] = useState(true) // ekranda gözükmesin diye simdilik yaptık bunu.Daha sonra yeri degisecek
	useEffect(() => {
	
		
		if (facebookPixelId) {
		  !(function (f, b, e, v, n, t, s) {
			if (f.fbq) return;
			n = f.fbq = function () {
			  n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
			};
			if (!f._fbq) f._fbq = n;
			n.push = n;
			n.loaded = !0;
			n.version = '2.0';
			n.queue = [];
			t = b.createElement(e);
			t.async = !0;
			t.src = v;
			s = b.getElementsByTagName(e)[0];
			s.parentNode.insertBefore(t, s);
		  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
		  window.fbq('init', facebookPixelId);
		  window.fbq('track', 'PageView');
		}
	  }, [ facebookPixelId]);

	useEffect(() => {
		if ((auth.getUserChoises()?.deliveryTab && auth.getUserChoises()?.deliveryType && auth.getUserChoises()?.deliveryTab != auth.getUserChoises()?.deliveryType) || localStorage.getItem('isSetUserChoise') && (location.pathname != '/kayit-ol' || location.pathname != '/uye-girisi' || location.pathname != '/teslimat-secimi' || location.pathname != '/misafir-girisi')) {
			navigate('/teslimat-secimi')
		}
		getSiteSEttings('Setting', {
			method: 'GET',
		}).then((res) => {
			dispatch(setSiteSEttings(res.data.result))
		})
		
	}, [openStatus])
	useEffect(() => {
		if ((auth.getUserChoises()?.deliveryTab != auth.getUserChoises()?.deliveryType) &&( auth.getUserChoises()?.neighbourhoodId || auth.getUserChoises()?.regionId )) {
			auth.updateUserChoises({deliveryTab:auth.getUserChoises()?.deliveryType})
		}
	}, [location])
	useEffect(() => {
			const token = auth.isHaveToken()
			if (!localStorage.getItem('lang')) {
				localStorage.setItem('lang',JSON.stringify('tr'))
			}
			if (
				!token ||
				(parameters?.deliveryType &&
					parameters?.neighbourhoodId &&
					parameters?.restaurantId &&
					(parameters?.deliveryType == 1 || parameters?.regionId))
			){
				if (triggerPopups.length < 1 ) {
					getSitePopups('Popup', {
						method: 'GET',
						headers: {
							restaurantId: auth.getUserChoises()?.restaurantId,
							deliveryType: auth.getUserChoises()?.deliveryType,
							neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
							regionId: auth.getUserChoises()?.regionId,
						}
					}).then((res) => {
							dispatch(setPopupList(res.data.result))
					})
				}
				
			}
	},[location])


	useEffect(() => {
		if (autoPopups.length > 0 && announcementModal.content == null) {
			const popups = auth.getPopups()
			if (popups && popups?.length > 0) {
				for (let pop of autoPopups) {
					const findedPopup = popups.find(p => p.id == pop.id)
					if (findedPopup) {
						const now = moment()
						const onShowDate = moment(findedPopup.onShowDate)
						const diffMinutes = now.diff(onShowDate,'minutes')
						if (pop.timeExpire != 0 && diffMinutes >= findedPopup.timeExpire) {
							dispatch(setAnnouncementModal({open:true, content:pop}))
							break;
						} else {
							continue;
						}
					} else {
						dispatch(setAnnouncementModal({open:true, content:pop}))
						break;
					}
				}
			
			} else {
				dispatch(setAnnouncementModal({
					open:true,
					content:autoPopups[0]
				}))
			}
		}
	},[autoPopups, announcementModal, location])
	useEffect(() => {
		if (location.pathname == '/kayit-ol' || location.pathname == '/uye-girisi' || location.pathname == '/teslimat-secimi' || location.pathname == '/misafir-girisi') {
			setNavbarStatus(true)
		} else {
			setNavbarStatus(false)
		}
	}, [location])
	
	const authToken = auth.getGuestToken() || auth.getToken()
	const parameters = auth.getUserChoises();
	useEffect(() => {

	  if ( authToken && (parameters?.deliveryType &&
		parameters?.neighbourhoodId &&
		parameters?.restaurantId &&
		(parameters?.deliveryType != 2 || parameters?.regionId))) {
		request('/ShoppingCart', {
		  method: 'GET',
		  headers: {
			restaurantId: auth.getUserChoises()?.restaurantId,
			deliveryType: auth.getUserChoises()?.deliveryType,
			neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
			regionId: auth.getUserChoises()?.regionId,
		  }
		}).then((res) => {
		  if (res) {
			dispatch(getAllBasketFunc(res?.data?.result))
		  }
		})
	  }
	}, [authToken,useTrigger])
	useEffect(() => {
		// dataLayer'ı başlatıyoruz
		const gtag = window.gtag || function () {
		  window.dataLayer.push(arguments);
		};
	  
		// Kullanıcı onay verilerini kontrol ediyoruz
		const hasCookie = auth.getCookieSelections();
		
		if (hasCookie) {
		  // Tüm gerekli alanların varlığını kontrol et ve varsayılan değerler ata
		  const consentUpdate = {
			'ad_storage': hasCookie.ad_storage || 'denied',
			'ad_user_data': hasCookie.ad_user_data || 'denied',
			'ad_personalization': hasCookie.ad_personalization || 'denied',
			'functionality_storage': hasCookie.functionality_storage || 'denied',
			'analytics_storage': hasCookie.analytics_storage || 'denied',
		  };
		  
		  gtag('consent', 'update', consentUpdate);
		  
		  // İsteğe bağlı: Bir dataLayer event'i de gönderebilirsiniz
		  window.dataLayer.push({
			'event': 'consent_loaded',
			...consentUpdate
		  });
		} else {
			  const consentUpdate = {
			'ad_storage': 'denied',
			'ad_user_data': 'denied',
			'ad_personalization': 'denied',
			'functionality_storage':'denied',
			'analytics_storage':  'denied',
		  };
		  
		  gtag('consent', 'update', consentUpdate);
		  
		  // İsteğe bağlı: Bir dataLayer event'i de gönderebilirsiniz
		  window.dataLayer.push({
			'event': 'consent_loaded',
			...consentUpdate
		  });
		} 
	  }, []);

	const redirectFunc = (url) => {
		navigate(url)
		dispatch(authModalOpen({open:false,returnUrl:''}))
	}

	const authModalContent = (
		<div className='allModal-content'>
		<img src={images.logo2} alt='' className='modal-container-img ' />
		<div className='allModal-content-btnGroup'>
			<div className='allModal-content-btnGroup-top'>
				<div onClick={() => redirectFunc(`/uye-girisi?returnUrl=${encodeURIComponent(authModal?.returnUrl)}`)} className='allModal-btn-one'>
					{t('loginBtn')}
				</div>
				<div  onClick={() => redirectFunc(`/kayit-ol?returnUrl=${encodeURIComponent(authModal?.returnUrl)}`)} className='allModal-btn-two'>
					{t('registerBtn')}
				</div>
			</div>
			<div className='allModal-content-btnGroup-bottom'>
				<div  onClick={() =>redirectFunc(`/misafir-girisi?returnUrl=${encodeURIComponent(authModal?.returnUrl)}`)} className='allModal-btn-three'>
					{t('withoutRegisterBtn')}
				</div>
			</div>
		</div>
	</div>
	)

	return (
		<div className='layout'>

			<Helmet titleTemplate={siteSettings?.seo?.titleTemplate}>
			  <meta charSet='utf-8' />	
			  <link rel="canonical" href={window.location.origin + window.location.pathname} /> 
			</Helmet>
			{navbarStatus ? <Navbar2 logoPath={logoPath} /> : <Navbar logoPath={logoPath} getAllBasket={getAllBasket}/>}
			<Outlet />
			{
				!loading && !siteSettingLoading && <>
				<Footer etbisUrl={etbisUrl} footerLogoPath={footerLogoPath} etbisImagePath={etbisImagePath} />
				<Copyright socialMedia={socialMedia} footerPhoneLogoPath={footerPhoneLogoPath} />
				</>
			}
			<AnnouncementModal/>
			<Modal
				onClose={pinMapModal.open}
				mmodalClass='pinmap-modal'
				title={t('addFromMap')}
				closeModal={() => dispatch(setPinMapModal({ open: false }))}
			>
				<PinMapContent />
			</Modal>
			{(!authToken && authModal.open) && <AllModal authModalContent={authModalContent} />}
			{ cookieOpen && !auth.getCookieAcception() && <Cookie cookieValues={cookieValues} setCookieValues={setCookieValues} setCookieOpen={setCookieOpen} />}
			{/* Diger alanlar bu kısma gelecek	 */}
		</div>
	)
}
Layout.propTypes = {
	siteSettings: PropTypes.shape({
		socialMedia: PropTypes.shape({
			facebook: PropTypes.string,
			twitter: PropTypes.string,
			instagram: PropTypes.string,
			youtube: PropTypes.string,
		}),
		common: PropTypes.shape({
			footerPhoneLogoPath: PropTypes.string,
			footerLogoPath: PropTypes.string,
		}),
	}),
}
export default Layout
